import { makeStyles, createStyles } from '@mui/styles';

export const useStyles = makeStyles(({ palette, spacing }) => {
  return createStyles({
    lanes: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },
    laneTitle: {
      padding: spacing(2),
    },
    lane: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },
    maneuver: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: spacing(3),
      borderTop: `1px solid ${palette.divider}`,
    },
  });
});
